import type { FinancialTableColumn } from "@/features/financialShared";

export const REVENUE_PROPERTY_COLUMNS: FinancialTableColumn[] = [
	{ id: "name", label: "Property Name" },
	{ id: "totalUnits", label: "Total Units" },
	{ id: "latestServicePeriod", label: "Latest Service Period" },
	{ id: "status", label: "Status" },
	{ id: "lastUpdatedDate", label: "Last Updated Date" },
	{ id: "approver", label: "Approver" },
];

export const REVENUE_SERVICE_PERIOD_COLUMNS: FinancialTableColumn[] = [
	{ id: "period", label: "Service Period" },
	{ id: "paidUnits", label: "Pay Out Units" },
	{ id: "status", label: "Status" },
	{ id: "createdDate", label: "Created Date" },
	{ id: "lastUpdated", label: "Last Updated" },
	{ id: "approver", label: "Approver" },
	{ id: "action", label: "Action", align: "right" },
];

export const REVENUE_UNIT_COLUMNS: FinancialTableColumn[] = [
	{ id: "unit", label: "Unit" },
	{ id: "owner", label: "Owner" },
	{ id: "nights", label: "Nights" },
	{ id: "netRevenue", label: "Net Revenue" },
	{ id: "ownerShare", label: "Owner Share (50%)" },
	{ id: "balanceToPay", label: "Balance to Pay" },
	{ id: "payoutMethod", label: "Payout Method" },
	{ id: "status", label: "Status" },
	{ id: "action", label: "Action", align: "right" },
];

export const REVENUE_RENTAL_ACTIVITY_COLUMNS: FinancialTableColumn[] = [
	{ id: "period", label: "Period" },
	{ id: "unit", label: "Unit" },
	{ id: "type", label: "Type" },
	{ id: "arrival", label: "Arrival" },
	{ id: "departure", label: "Departure" },
	{ id: "resvNights", label: "Resv Nights" },
	{ id: "netRoomRevenue", label: "Net Room Revenue" },
];

export const REVENUE_PROPERTY_TABLE_MIN_WIDTH = "min-w-[900px]";
export const REVENUE_PERIOD_TABLE_MIN_WIDTH = "min-w-[960px]";
export const REVENUE_UNIT_TABLE_MIN_WIDTH = "min-w-[1100px]";
export const REVENUE_ACTIVITY_TABLE_MIN_WIDTH = "min-w-[800px]";
export const REVENUE_SUMMARY_TABLE_MIN_WIDTH = "min-w-[700px]";
export const REVENUE_PAGE_SIZE = 10;

export const REVENUE_LISTING_STATUS_FILTER = [
	{ value: "ALL", label: "All Statuses" },
	{ value: "DRAFT", label: "Draft" },
	{ value: "PUBLISHED", label: "Published" },
	{ value: "COMPLETED", label: "Completed" },
] as const;

export const REVENUE_LISTING_SORT_OPTIONS = [
	{ value: "NAME", label: "Property Name" },
	{ value: "TOTAL_UNITS", label: "Total Units" },
	{ value: "LAST_UPDATED", label: "Last Updated" },
] as const;

export const REVENUE_PERIOD_FILE_MAX_MB = 20;
export const REVENUE_PERIOD_FILE_ACCEPT = ".xlsx,.xls";

export const REVENUE_UNIT_STATUS_FILTER = [
	{ value: "ALL", label: "All Statuses" },
	{ value: "SETTLED", label: "Settled" },
	{ value: "IN_PROGRESS", label: "In Progress" },
	{ value: "HOLD", label: "Hold" },
] as const;

export const REVENUE_UNIT_PAYOUT_METHOD_FILTER = [
	{ value: "ALL", label: "All Methods" },
	{ value: "BANK_TRANSFER", label: "Bank Transfer" },
	{ value: "CARD", label: "Card" },
	{ value: "CHEQUE", label: "Cheque" },
] as const;

export const REVENUE_UNIT_SORT_OPTIONS = [
	{ value: "UNIT", label: "Unit" },
	{ value: "TOTAL_PAYOUT", label: "Total Payout" },
	{ value: "STATUS", label: "Status" },
] as const;

export const REVENUE_STATEMENT_STATUS_OPTIONS = [
	{ value: "SETTLED", label: "Settled" },
	{ value: "IN_PROGRESS", label: "In Progress" },
	{ value: "HOLD", label: "Hold" },
] as const;

export const REVENUE_PAYOUT_METHOD_OPTIONS = [
	{ value: "BANK_TRANSFER", label: "Bank Transfer" },
	{ value: "CARD", label: "Card" },
	{ value: "CHEQUE", label: "Cheque" },
] as const;
